import http from "@/axios/http-common";
import {
  SatusehatJenisKirimUlang,
  SatusehatKirimUlangResponse,
  SatusehatKunjunganResponse,
  SatusehatRingkasanResponse
} from "@/types/satusehat_monitor";

async function ringkasan(hari: number): Promise<SatusehatRingkasanResponse> {
  const res = await http.getDataParam("/satusehat-monitor/ringkasan", {
    params: { hari }
  });

  return res.data.data;
}

async function kunjungan(
  tgl: string,
  unit: string | null
): Promise<SatusehatKunjunganResponse> {
  const res = await http.getDataParam("/satusehat-monitor/kunjungan", {
    params: { tgl, unit: unit || undefined }
  });

  return res.data.data;
}

async function kirimUlang(
  register: string,
  jenis: SatusehatJenisKirimUlang
): Promise<SatusehatKirimUlangResponse> {
  const res = await http.postData("/satusehat-monitor/kirim-ulang", {
    register,
    jenis
  });

  return res.data.data;
}

export default { ringkasan, kunjungan, kirimUlang };
